export const isPartyAllowedByNewAttrs = (party, attrs = []) => {
  if (!party) return false;
  const { subPartyRoleId, partyType } = party;
  if (!subPartyRoleId) return false;
  return attrs.some((attr) => attr.partyRoleId == subPartyRoleId && attr.partyTypeId == partyType);
};
export const computeIncompatibleParties = ({
  pros = [], // prosecutors
  defs = [], // defendants
  newAttrsPros = [], // attributes for prosecutors
  newAttrsDefs = [], // attributes for defendants
  newDefsAllowed = true, // does the new case type allow defendants
}) => {
  // Prosecutors
  let incompatiblePros = [];
  if (pros.length) {
    if (newAttrsPros?.length > 0) {
      incompatiblePros = pros.filter((p) => !isPartyAllowedByNewAttrs(p, newAttrsPros));
    } else if (pros.some((p) => !!p.subPartyRoleId)) {
      incompatiblePros = pros.slice();
    }
  }
  // Defendants
  let incompatibleDefs = [];
  if (defs.length) {
    if (!newDefsAllowed) {
      incompatibleDefs = defs.slice();
    } else if (newAttrsDefs?.length > 0) {
      incompatibleDefs = defs.filter((d) => !isPartyAllowedByNewAttrs(d, newAttrsDefs));
    } else if (defs.some((d) => !!d.subPartyRoleId)) {
      incompatibleDefs = defs.slice();
    }
  }
  return { incompatiblePros, incompatibleDefs };
};
